import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import PropTypes from 'prop-types';
import { Warning, Ok, Gear, User, Wait, Clear, Money, HelpCircle, Kebab } from "../svg";
var MAP = {
  warning: Warning,
  ok: Ok,
  gear: Gear,
  user: User,
  wait: Wait,
  clear: Clear,
  money: Money,
  'help-circle': HelpCircle,
  kebab: Kebab
};
export var Icon = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Icon, _React$Component);

  function Icon() {
    return _React$Component.apply(this, arguments) || this;
  }

  Icon.getAllNames = function getAllNames() {
    return Object.keys(MAP);
  };

  var _proto = Icon.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        name = _this$props.name,
        color = _this$props.color;
    return /*#__PURE__*/React.createElement(MAP[name], {
      color: color
    });
  };

  return Icon;
}(React.Component);
Icon.__KONTUR_REACT_UI__ = 'Icon20px';
Icon.propTypes = {
  color: PropTypes.string,

  /**
  * Icon id.
  */
  name: PropTypes.oneOf(Object.keys(MAP))
};